
const m = window.require("I18n");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
